import { StateService, Transition, UIRouter } from '@uirouter/core';

export class UserProfileRouterConfigService {
  private static readonly GAML_DELAY_TIME: number = 2000;
  private static readonly GAML_MODAL_ROUTE: string = 'modal.gaml';
  private static readonly GAML_DISPLAY_ROUTES: Array<string> = [
    'page.profile.address-success',
    'page.profile.employment-success',
    'page.profile.email-success',
    'page.profile.phone-success'
  ];

  static isGamlAvailable: boolean = false;

  static routerConfig(uiRouter: UIRouter): void {
    UserProfileRouterConfigService.initHooks(uiRouter);
  }

  private static initHooks(uiRouter: UIRouter): void {
    UserProfileRouterConfigService.registerGamlModalOnPages(uiRouter);
  }

  private static registerGamlModalOnPages(uiRouter: UIRouter): void {
    UserProfileRouterConfigService.GAML_DISPLAY_ROUTES.forEach((route: string) => {
      uiRouter.transitionService.onSuccess(
        { to: route },
        () => {
          if(UserProfileRouterConfigService.isGamlAvailable) {
            UserProfileRouterConfigService.navigateToGaml(uiRouter);
          }
        }
      );
    });
  }

  private static navigateToGaml(uiRouter: UIRouter): void {
    const stateService: StateService = uiRouter.stateService;

    const delayedTransitionTimeoutId = setTimeout(() => {
      deregisterDelayedTransitionTimeoutHook();
      stateService.go(UserProfileRouterConfigService.GAML_MODAL_ROUTE);
      UserProfileRouterConfigService.isGamlAvailable = false;
    }, UserProfileRouterConfigService.GAML_DELAY_TIME);

    const deregisterDelayedTransitionTimeoutHook =
      uiRouter.transitionService.onBefore(
        { to: '**' },
        (transition: Transition) => {
          clearTimeout(delayedTransitionTimeoutId);
          transition.promise.then(() => {
            stateService.go(UserProfileRouterConfigService.GAML_MODAL_ROUTE);
            UserProfileRouterConfigService.isGamlAvailable = false;
          })
        },
        { invokeLimit: 1 }
      );
  }
}
